import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "../ui/switch";
import { api, adminApi, errMsg } from "../../lib/api";

export const SiteSettings = () => {
  const [on, setOn] = useState(null);
  useEffect(() => { api.get("/settings").then((r) => setOn(r.data.xmas_banner)); }, []);
  const toggle = (v) => {
    setOn(v);
    adminApi().put("/admin/settings", { xmas_banner: v })
      .then(() => toast.success(v ? "Christmas banner is live on the home page" : "Christmas banner hidden"))
      .catch((e) => { setOn(!v); toast.error(errMsg(e)); });
  };
  return (
    <label className="mt-5 flex max-w-xl items-center justify-between gap-4 border-2 border-red-600 bg-red-50 p-4" data-testid="admin-xmas-setting">
      <span><span className="block font-bold">Christmas banner on home page</span>
        <span className="text-xs text-slate-600">"Order early for Christmas delivery to avoid disappointment"</span></span>
      <Switch checked={!!on} disabled={on === null} onCheckedChange={toggle} data-testid="admin-xmas-banner-switch" />
    </label>
  );
};
